import API from "../../api/axios"


export const getClinicSetting=async()=>{
  const authToken = localStorage.getItem("authToken")
  const res = await API.get("/clinicSetting", {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
  })

  return res.data
}